var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "examRoom" }, [
    _c("div", { staticClass: "left" }, [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "classify", attrs: { id: "type" } }, [
          _c("p", [_vm._v("分类：")]),
          _vm._v(" "),
          _c(
            "ul",
            [
              _c(
                "li",
                {
                  staticClass: "active",
                  on: {
                    click: function($event) {
                      return _vm.queryListByType("", 0)
                    }
                  }
                },
                [_vm._v("不限")]
              ),
              _vm._v(" "),
              _vm._l(_vm.examTypeList, function(t, key) {
                return _c(
                  "li",
                  {
                    attrs: { title: t.label },
                    on: {
                      click: function($event) {
                        return _vm.queryListByType(t.value, key + 1)
                      }
                    }
                  },
                  [_vm._v(_vm._s(t.label))]
                )
              })
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "classify", attrs: { id: "category" } }, [
          _c("p", [_vm._v("类别：")]),
          _vm._v(" "),
          _c(
            "ul",
            [
              _c(
                "li",
                {
                  staticClass: "active",
                  on: {
                    click: function($event) {
                      return _vm.queryListByCategory("", 0)
                    }
                  }
                },
                [_vm._v("不限")]
              ),
              _vm._v(" "),
              _vm._l(_vm.categorylist, function(l, key) {
                return _c(
                  "li",
                  {
                    attrs: { title: l.name },
                    on: {
                      click: function($event) {
                        return _vm.queryListByCategory(l.id, key + 1)
                      }
                    }
                  },
                  [_vm._v(_vm._s(l.name))]
                )
              })
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "room-text" },
        [
          !_vm.success
            ? _c("p", { staticClass: "tj-shift-notice" }, [
                _vm._v(_vm._s(_vm.message))
              ])
            : !_vm.examlist.length
            ? [
                _c("p", { staticClass: "tj-shift-notice" }, [
                  _vm._v("暂无记录")
                ])
              ]
            : [
                _c(
                  "ul",
                  { staticClass: "clear" },
                  _vm._l(_vm.examlist, function(e) {
                    return _c("li", [
                      _c(
                        "div",
                        { staticClass: "content" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "tj-link-blue tj-inblock",
                              attrs: {
                                to: {
                                  name: "examDetail",
                                  params: { id: e.examConfigId }
                                }
                              }
                            },
                            [
                              _c("div", {
                                staticClass: "zoomImage",
                                style: _vm.style(e.examConfig.iconUrl)
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "text" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "title",
                                    attrs: { title: e.examConfig.name }
                                  },
                                  [_vm._v(_vm._s(e.examConfig.name))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  [
                                    e.examConfig.examType == "Formal"
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "formal",
                                              attrs: { title: "正式考试" }
                                            },
                                            [_vm._v("正")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "iconfont icon-people"
                                            },
                                            [
                                              e.examConfig.registerNum != null
                                                ? [
                                                    _vm._v("已有"),
                                                    _c("i", [
                                                      _vm._v(
                                                        _vm._s(
                                                          e.examConfig
                                                            .registerNum
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v("人报名")
                                                  ]
                                                : [
                                                    _vm._v("已有"),
                                                    _c("i", [_vm._v("0")]),
                                                    _vm._v("人报名")
                                                  ]
                                            ],
                                            2
                                          )
                                        ]
                                      : e.examConfig.examType == "Practice"
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "practice",
                                              attrs: {
                                                title: "模拟练习，可多次练习"
                                              }
                                            },
                                            [_vm._v("练")]
                                          )
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  }),
                  0
                ),
                _vm._v(" "),
                _c("pagination", {
                  attrs: { pages: _vm.pages, pageNum: _vm.pageNum },
                  on: { getData: _vm.getList }
                })
              ]
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-210fdb54", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-210fdb54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/examList.vue
// module id = 1112
// module chunks = 0